import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=e19912c6&scoped=true&"
import script from "./newsCenter.vue?vue&type=script&lang=js&"
export * from "./newsCenter.vue?vue&type=script&lang=js&"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=e19912c6&scoped=true&lang=less&"
import style1 from "./newsCenter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19912c6",
  null
  
)

export default component.exports